export const basic = [
    ["font", "fontSize"],
    ["fontColor"],
    ["horizontalRule"],
    ["link", "image"]
  ];
  
  export const complex = [
    ["undo", "redo"],
    ["font", "fontSize", "formatBlock"],
    ["bold", "underline", "italic", "strike", "subscript", "superscript"],
    ["removeFormat"],
    "/",
    ["fontColor", "hiliteColor"],
    ["outdent", "indent"],
    ["align", "horizontalRule", "list", "table"],
    ["link", "image", "video"],
    ["fullScreen", "showBlocks", "codeView"],
    ["preview", "print"],
    ["save", "template"]
  ];
  
  export const formatting = [
    ["undo", "redo"],
    ["bold", "underline", "italic", "strike", "subscript", "superscript"],
    ["removeFormat"],
    ["outdent", "indent"],
    ["fullScreen", "showBlocks", "codeView"],
    ["preview", "print"]
  ];
  export default { basic, complex, formatting };